module.exports = __webpack_public_path__ + "img/chinesecompany49.8985288e.png";